
<app-tablelayout [data]="students" [columns]="columns" [columnsToRemove]="removeColumn" [count]="count" [offset]="offset"
  [filterItems]="filterOptions" [allowExport]="true" exportFileName="unregistered-students"
  (loadDataEvent)="loadTableData($event)" [allowMultiSelect]="true" [selectBy]="selectBy" [operation]="operations"
  (onItemSelected)="itemSelected($event)" (onOperationActionFired)="setBatchId($event)"><app-tablelayout />
